// Chart Component - Handles trade visualization and charts
export class ChartComponent {
    constructor() {
        this.chartContainer = null;
        this.currentChart = null;
        this.chartData = [];
        
        this.initializeChart();
    }

    /**
     * Initialize chart component
     */
    initializeChart() {
        this.chartContainer = document.getElementById('chart-container');
        if (!this.chartContainer) {
            console.warn('Chart container not found');
            return;
        }
        
        // Create basic chart placeholder
        this.createChartPlaceholder();
    }

    /**
     * Create chart placeholder
     */
    createChartPlaceholder() {
        if (!this.chartContainer) return;
        
        // Clear container safely
        while (this.chartContainer.firstChild) {
            this.chartContainer.removeChild(this.chartContainer.firstChild);
        }
        
        // Create safe DOM elements instead of innerHTML
        const placeholder = document.createElement('div');
        placeholder.className = 'chart-placeholder';
        
        const chartInfo = document.createElement('div');
        chartInfo.className = 'chart-info';
        
        const title = document.createElement('h3');
        title.textContent = 'Trade Visualization';
        
        const description = document.createElement('p');
        description.textContent = 'Chart functionality ready for implementation';
        
        const statsDiv = document.createElement('div');
        statsDiv.className = 'chart-stats';
        
        const totalTradesSpan = document.createElement('span');
        totalTradesSpan.className = 'stat-item';
        totalTradesSpan.textContent = 'Total Trades: ';
        const totalTradesValue = document.createElement('span');
        totalTradesValue.id = 'chart-total-trades';
        totalTradesValue.textContent = '0';
        totalTradesSpan.appendChild(totalTradesValue);
        
        const activeAssetsSpan = document.createElement('span');
        activeAssetsSpan.className = 'stat-item';
        activeAssetsSpan.textContent = 'Active Assets: ';
        const activeAssetsValue = document.createElement('span');
        activeAssetsValue.id = 'chart-active-assets';
        activeAssetsValue.textContent = '0';
        activeAssetsSpan.appendChild(activeAssetsValue);
        
        statsDiv.appendChild(totalTradesSpan);
        statsDiv.appendChild(activeAssetsSpan);
        
        chartInfo.appendChild(title);
        chartInfo.appendChild(description);
        chartInfo.appendChild(statsDiv);
        
        placeholder.appendChild(chartInfo);
        this.chartContainer.appendChild(placeholder);
    }

    /**
     * Update chart with new data
     * @param {Array} trades - Array of trade objects
     */
    updateChart(trades) {
        this.chartData = trades || [];
        
        // Update stats
        const totalTrades = document.getElementById('chart-total-trades');
        const activeAssets = document.getElementById('chart-active-assets');
        
        if (totalTrades) {
            totalTrades.textContent = this.chartData.length;
        }
        
        if (activeAssets) {
            const uniqueAssets = new Set(this.chartData.map(trade => trade.asset)).size;
            activeAssets.textContent = uniqueAssets;
        }
    }

    /**
     * Render chart with current data
     */
    render() {
        if (!this.chartContainer || !this.chartData.length) return;
        
        // Basic implementation - can be enhanced with actual charting library
        // console.log(`Chart rendering ${this.chartData.length} trades`);
    }

    /**
     * Clear chart data
     */
    clear() {
        this.chartData = [];
        this.updateChart([]);
    }

    /**
     * Get chart data
     * @returns {Array} Current chart data
     */
    getData() {
        return this.chartData;
    }
}

// Export for global access
window.ChartComponent = ChartComponent;
